import { FC } from 'react'
import { SvgProps } from './svgProps'

const TwitterIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || 20}
    height={height || 17}
    viewBox="0 0 20 17"
  >
    <g fill="none" fillRule="evenodd">
      <g fill={color || '#FFF'}>
        <path
          d="M20 2.012c-.735.342-1.526.573-2.356.676.848-.53 1.498-1.372 1.804-2.374-.793.491-1.67.849-2.607 1.04C16.094.521 15.027 0 13.846 0c-2.264 0-4.101 1.922-4.101 4.291 0 .337.035.663.105.978-3.41-.18-6.433-1.886-8.458-4.486-.353.636-.555 1.374-.555 2.16 0 1.488.724 2.802 1.825 3.572-.671-.02-1.305-.216-1.859-.535v.053c0 2.08 1.415 3.815 3.293 4.208-.344.1-.707.15-1.081.15-.265 0-.523-.025-.773-.076.523 1.705 2.037 2.946 3.833 2.98-1.404 1.151-3.174 1.837-5.096 1.837-.331 0-.659-.02-.979-.059C1.816 16.29 3.974 17 6.29 17c7.548 0 11.674-6.538 11.674-12.21 0-.187-.003-.373-.01-.556.802-.606 1.498-1.36 2.046-2.222"
          transform="translate(-663 -89) translate(663 89)"
        />
      </g>
    </g>
  </svg>
)

export default TwitterIcon
